import { PageWrapper } from '@src/components';
import { ReactComponent as InviteImage } from '@src/assets/images/Invite.svg';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Copy } from 'iconsax-react';
import { message } from 'antd';
import { Button, Input } from '@devotel/design-system';

export function InviteFriends() {
  const { t } = useTranslation();
  const [referralCode, setReferralCode] = useState('');

  const copyToClipboard = () => {
    if (referralCode) {
      navigator.clipboard.writeText(referralCode);
      message.open({
        type: 'success',
        content: 'Referral code copied!',
        className: 'response-success',
      });
    }
  };

  const shareReferralCode = async () => {
    //todo: ther should be a url to share the referral code
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'My Referral Code',
          text: `Use my referral code: ${referralCode}`,
          url: `${window.location.origin}/referral/${referralCode}`,
        });
      } catch (error) {
        message.error('Sharing failed.');
      }
    } else {
      message.warning('Sharing is not supported on this browser.');
    }
  };

  return (
    <PageWrapper title={t('pages.inviteFriends.title')}>
      <div className='flex justify-center'>
        <div className='flex flex-col items-center max-w-md gap-8'>
          <InviteImage className='w-full max-h-[200]' />
          <p className='text-lg font-bold'>
            Share amazing eSIM Technology with Friends
          </p>
          <div className='w-full'>
            your referral code
            <Input
              value={referralCode}
              onChange={(e) => setReferralCode(e.target.value)}
              className='w-full'
              suffix={
                <Copy
                  variant='Bulk'
                  className='text-wl-primary hover:opacity-80 cursor-pointer'
                  onClick={copyToClipboard}
                />
              }
            />
          </div>
          <Button className='w-full btn-primary' onClick={shareReferralCode}>
            Share Now!
          </Button>
        </div>
      </div>
    </PageWrapper>
  );
}
